import moment from 'moment';
import {Biotwin, BiotwinCondition, RelevantCondition} from '../types';
import {BiobookPage} from '../../biobook/types';

const demographicConditionNames = ['Adult', 'Female', 'Male'];

export const isDemographic = (arg: string | RelevantCondition) => {
  return demographicConditionNames.includes(typeof arg === 'string' ? arg : arg.conditionName);
};

export const isInPerioperative = (biotwinCondition: BiotwinCondition) => {
  const date = biotwinCondition.date;
  if (date == null) {
    return false;
  }
  const dateMoment = moment(date.split('-').concat(['01', '01']).slice(0, 3).join('-'), 'YYYY-MM-DD');
  return moment().isBetween(dateMoment, dateMoment.clone().add(90, 'days'), 'day', '[]');
};

export const isNeoplastic = (arg: string | BiobookPage) => {
  return /neoplastic/i.test(typeof arg === 'string' ? arg : arg.mechanismLabelName);
};

export const isPerioperativeSetting = (arg: string | RelevantCondition) => {
  return /perioperative setting/i.test(typeof arg === 'string' ? arg : arg.conditionName);
};

export const isProcedure = (relevantCondition: RelevantCondition) => {
  return relevantCondition.conditionTypeName === 'Procedures';
};

export const isCompleteBiotwin = (biotwin: Biotwin | undefined) => {
  return (
    biotwin != null &&
    biotwin.age != null &&
    biotwin.height != null &&
    biotwin.height >= 0 &&
    biotwin.weight != null &&
    biotwin.weight >= 0 &&
    biotwin.gender != null
  );
};
